import { FieldType, FormFieldSettings, RenderType } from '../types/forms';

export function useFormFieldConfig(fieldType: FieldType) {
  const defaultSettings = {
    help_text: true,
    renderType: 'input' as RenderType,
  };
  const settings: { [key in FieldType]: FormFieldSettings } = {
    boolean: {
      ...defaultSettings,
      prefix: false,
      sufix: false,
      default: true,
      options: false,
      renderType: 'checkbox',
      inputType: 'select',
      isDeviceId: false,
    },
    email: {
      ...defaultSettings,
      prefix: true,
      sufix: true,
      default: false,
      options: false,
      inputType: 'email',
      isDeviceId: false,
    },
    string: {
      ...defaultSettings,
      prefix: true,
      sufix: true,
      default: true,
      options: false,
      inputType: 'text',
      relatedAttribute: true,
      isDeviceId: true,
    },
    text: {
      ...defaultSettings,
      prefix: false,
      sufix: false,
      default: true,
      options: false,
      renderType: 'textarea',
      isDeviceId: true,
    },
    choice: {
      ...defaultSettings,
      prefix: false,
      sufix: false,
      default: true,
      options: true,
      renderType: 'radio',
      inputType: 'select',
      isDeviceId: false,
    },
    multiple_choice: {
      ...defaultSettings,
      prefix: false,
      sufix: false,
      default: false,
      options: true,
      renderType: 'select',
      isDeviceId: false,
    },
    date: {
      ...defaultSettings,
      prefix: false,
      sufix: false,
      default: false,
      options: false,
      renderType: 'date',
      isDeviceId: false,
    },
    time: {
      ...defaultSettings,
      prefix: false,
      sufix: false,
      default: false,
      options: false,
      renderType: 'time',
      isDeviceId: false,
    },
    datetime: {
      ...defaultSettings,
      prefix: false,
      sufix: false,
      default: false,
      options: false,
      renderType: 'datetime',
      isDeviceId: false,
    },
    duration: {
      ...defaultSettings,
      prefix: true,
      sufix: true,
      default: true,
      options: false,
      inputType: 'number',
      isDeviceId: false,
    },
    file: {
      ...defaultSettings,
      prefix: false,
      sufix: false,
      default: false,
      options: false,
      renderType: 'canvas',
      isDeviceId: false,
    },
    image: {
      ...defaultSettings,
      prefix: false,
      sufix: false,
      default: false,
      options: false,
      renderType: 'canvas',
      isDeviceId: false,
    },
    integer: {
      ...defaultSettings,
      prefix: true,
      sufix: true,
      default: true,
      options: false,
      inputType: 'number',
      isDeviceId: false,
    },
    float: {
      ...defaultSettings,
      prefix: true,
      sufix: true,
      default: true,
      options: false,
      inputType: 'number',
      isDeviceId: false,
    },
    ip_address: {
      ...defaultSettings,
      prefix: true,
      sufix: true,
      default: false,
      options: false,
      inputType: 'text',
      isDeviceId: false,
    },
    url: {
      ...defaultSettings,
      prefix: true,
      sufix: true,
      default: false,
      options: false,
      inputType: 'text',
      isDeviceId: false,
    },
    signature: {
      ...defaultSettings,
      prefix: false,
      sufix: false,
      default: false,
      options: false,
      renderType: 'canvas',
      isDeviceId: false,
    },
    canvas: {
      ...defaultSettings,
      prefix: false,
      sufix: false,
      default: false,
      options: false,
      renderType: 'canvas',
      isDeviceId: false,
    },
  };

  const fieldTypeSettings = settings[fieldType];

  return {
    showPrefix: fieldTypeSettings.prefix,
    showSufix: fieldTypeSettings.sufix,
    showHelpText: fieldTypeSettings.help_text,
    showDefault: fieldTypeSettings.default,
    showOptions: fieldTypeSettings.options,
    renderType: fieldTypeSettings.renderType,
    inputType: fieldTypeSettings.inputType,
    showRelatedAttribute: fieldTypeSettings.relatedAttribute,
    showIsDeviceId: fieldTypeSettings.isDeviceId,
  };
}
